import { render, staticRenderFns } from "./Showdown.vue?vue&type=template&id=5c6609ee&"
import script from "./Showdown.vue?vue&type=script&lang=js&"
export * from "./Showdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6609ee')) {
      api.createRecord('5c6609ee', component.options)
    } else {
      api.reload('5c6609ee', component.options)
    }
    module.hot.accept("./Showdown.vue?vue&type=template&id=5c6609ee&", function () {
      api.rerender('5c6609ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Showdown.vue"
export default component.exports